import { useIsFs2FinalRelease } from "../useIsFs2FinalRelease/useIsFs2FinalRelease";

const useIsFs2JanRelease = () => {
  return useIsFs2FinalRelease();
};

export { useIsFs2JanRelease };
